// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".order-notification-item{margin:10px 0}", "",{"version":3,"sources":["webpack://./resources/antd-pro/pages/admin/master/payment/partner/master-space-payment.vue"],"names":[],"mappings":"AACA,yBACE,aAAF","sourcesContent":["\n.order-notification-item {\n  margin: 10px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
